var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M201.373 73.373l-160 160c-12.497 12.496-12.497 32.758 0 45.254l160 160c12.497 12.496 32.758 12.496 45.255 0 12.498-12.496 12.498-32.758 0-45.254L141.254 288H448c17.673 0 32-14.326 32-32 0-17.673-14.327-32-32-32H141.254l105.373-105.373C252.875 112.379 256 104.189 256 96s-3.124-16.379-9.372-22.627c-12.498-12.497-32.758-12.497-45.255 0z"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
